import React, { ButtonHTMLAttributes } from 'react';
import { useCalendarYear } from '@src/domains/scheduling/components/CalendarYearContext';
import MonthThumb from '@src/domains/scheduling/components/MonthThumb';
import { MonthCardButton, MonthCardLabel } from './styles';

type MonthCardProps = ButtonHTMLAttributes<HTMLButtonElement> & { 'data-month'?: string };

const parseMonthIndex = (raw: unknown): number | null => {
  if (typeof raw !== 'string') return null;
  const parsed = Number.parseInt(raw, 10);
  return Number.isInteger(parsed) ? parsed : null;
};

const MonthCard = (props: MonthCardProps) => {
  const { children, 'data-month': dataMonth, ...rest } = props;
  const year = useCalendarYear();
  const monthIndex = parseMonthIndex(dataMonth);

  const ariaLabel = typeof rest['aria-label'] === 'string' ? rest['aria-label'] : '';
  const label = ariaLabel || children;

  return (
    <MonthCardButton type='button' {...rest}>
      <MonthCardLabel>{label}</MonthCardLabel>
      {monthIndex !== null ? <MonthThumb monthTuple={[year, monthIndex + 1]} /> : null}
    </MonthCardButton>
  );
};

export default MonthCard;
